var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "roundedIcons/chevron-circle-up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 5C9.92487 5 5 9.92487 5 16C5 22.0751 9.92487 27 16 27C22.0751 27 27 22.0751 27 16C27 9.92487 22.0751 5 16 5ZM3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16ZM8.62623 17.9596L15.2929 11.2929C15.6834 10.9024 16.3166 10.9024 16.7071 11.2929L23.3738 17.9596C23.7643 18.3501 23.7643 18.9833 23.3738 19.3738C22.9833 19.7643 22.3501 19.7643 21.9596 19.3738L16 13.4142L10.0404 19.3738C9.64992 19.7643 9.01675 19.7643 8.62623 19.3738C8.2357 18.9833 8.2357 18.3501 8.62623 17.9596Z",
    fill: "black",
    fillOpacity: 0.16
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleArrowUp);
export default __webpack_public_path__ + "static/media/circle-arrow-up.8e23515bcde8bdcbfec61e452ec784dc.svg";
export { ForwardRef as ReactComponent };